import React, { useEffect, useRef, useState } from "react";
import {
  booking,
  booking_active,
  left_arrow,
  master_img,
  no_image,
  profile_img,
} from "../../assets/imgs";
import { useLocation, useNavigate } from "react-router-dom";
import CancelIcon from "@mui/icons-material/Cancel";
import Select from "react-select";
import {
  useBannerListAddMutation,
  useBannerListEditMutation,
  useBannerLocationViewMutation,
  useLazyBannerLocationViewQuery,
  useLazyBannerViewQuery,
} from "../redux/api/api";
import { toast } from "react-toastify";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Spinner } from "react-bootstrap";

const AddBanners = () => {
  const navigate = useNavigate();
  const [value, setValue] = useState();
  const [url, setUrl] = useState();
  const [upload, setUpload] = useState(false);
  const [stateValue, setStateValue] = useState();
  const [cityValue, setCityValue] = useState();
  const [countryValue, setCountryValue] = useState();
  const [selectedStateValue, setSelectedStateValue] = useState();
  const [selectedCityValue, setSelectedCityValue] = useState();
  const [selectedCountryValue, setSelectedCountryValue] = useState();
  const [startDate, setStartDate] = useState(moment(new Date).format("YYYY-MM-DD"));
  const [startTime, setStartTime] = useState();
  const [endTime, setEndTime] = useState();
  const [endDate, setEndDate] = useState(moment(new Date).format("YYYY-MM-DD"));
  const [loader, setLoader] = useState(false);
  const location = useLocation();
  const [images, setImages] = useState([]);
  const [imageData, setImageData] = useState([]);
  const [count, setCount] = useState();
  const ref = useRef();
  // console.log("loc", location.state);

  const addId = location?.state?.id;
  const id = location?.state?.id;
  const type = location?.state?.type;
  console.log("id", location?.state);
  console.log("date", startDate);

  const [bannerViewApi] = useLazyBannerViewQuery();
  const [bannerAddApi] = useBannerListAddMutation();
  const [bannerEditApi] = useBannerListEditMutation();
  const [bannerlocationApi] = useBannerLocationViewMutation();

  const bannerAdd = () => {

    if (!selectedCountryValue) {
      toast.error("Select Country");
      return;
    }
    if (!selectedStateValue) {
      toast.error("Select State");
      return;
    }
    if (!selectedCityValue) {
      toast.error("Select City");
      return;
    }

    if (!startDate) {
      toast.error("Enter start Date");
      return;
    }
    if (!endDate) {
      toast.error("Enter End Date");
      return;

    }
    if (images?.length == 0) {
      toast.error("Upload Images");
      return;

    }
    const formdata = new FormData();
    formdata.append("city_id", selectedCityValue?.value);
    images.map((item, ind) => {
      if (item?.image) {
        formdata.append(`image[${ind}]`, item?.image);
      }
      formdata.append(`redirect_url[${ind}]`, item?.redirection_url);
      formdata.append(`position[${ind}]`, ind);
    });
    formdata.append("start_datetime", `${moment(startDate).format("YYYY-MM-DD")} ${startTime}`);
    formdata.append("end_datetime", `${moment(endDate).format("YYYY-MM-DD")} ${endTime}`);

    setLoader(true);
    bannerAddApi(formdata)
      .unwrap()
      .then((res) => {
        console.log("res", res);
        if (res?.status == "success") {
          setLoader(false);
          toast.success(res?.message);
          navigate(-1);
        }
      })
      .catch((err) => {
        setLoader(false);
        console.log("err", err);
      }).finally(() => {
        setLoader(false);
      })
  };
  // console.log("date", startTime);

  const handleChange = (event) => {
    const files = event.target.files;
    if (files) {
      const filesArray = Array.from(files);

      // Check if adding these files will exceed the limit of 10
      if (images.length + filesArray.length > 10) {
        alert("You can only upload a maximum of 10 images.");
        return;
      }

      // Add new files to the existing images
      let temp = [...images];

      filesArray?.map((item, ind) => {
        temp.push({
          image: item,
          image_url: "",
        });
      });

      setImages(temp);
      // setImages((prevImages) => [...prevImages, ...filesArray]);
    }
  };

  const handleImgUrl = (event, ind) => {
    let temp = [...images];
    temp[ind] = {
      ...temp[ind],
      redirection_url: event,
    };
    setImages(temp);
  };
  console.log("urlss", images);


  const bannerEdit = () => {
    if (images?.length == 0) {
      toast.error("Upload Images");
      return;

    }
    const formdata = new FormData();
    formdata.append("city_id", selectedCityValue?.value);
    images.map((item, ind) => {
      if (item?.image) {
        formdata.append(`image[${ind}]`, item?.image);
      }
      formdata.append(`redirect_url[${ind}]`, item?.redirection_url);
      formdata.append(`position[${ind}]`, ind);
    });
    formdata.append("start_datetime", `${moment(startDate).format("YYYY-MM-DD")} ${startTime}`);
    formdata.append("end_datetime", `${moment(endDate).format("YYYY-MM-DD")} ${endTime}`);
    setLoader(true);
    bannerEditApi({ payload: formdata, id: id })
      .unwrap()
      .then((res) => {
        console.log("res", res);
        if (res?.status == "success") {
          setLoader(false);
          toast.success(res?.message);
          navigate(-1);
          setCityValue("");
          setStartDate("");
          setStartTime("");
          setEndDate("");
          setEndTime("");
          setUrl("");
          setImages([]);
        }
      })
      .catch((err) => {
        setLoader(false);
        console.log("err", err);
      }).finally(() => {
        setLoader(false);
      })
  };

  const adminView = (id) => {
    bannerViewApi(id)
      .unwrap()
      .then((res) => {
        // console.log("res", res);
        // if (res?.admin) {
        locationStateView(res?.data?.country?.id);
        locationCityView(res?.data?.state?.id);
        setSelectedCountryValue({ value: res?.data?.country?.id, label: res?.data?.country?.name });
        setSelectedStateValue({ value: res?.data?.state?.id, label: res?.data?.state?.name });
        setSelectedCityValue({ value: res?.data?.city?.id, label: res?.data?.city?.name });
        // setStartDate(res?.data?.start_datetime?.split("T")[0]); // Extract date part
        setStartTime(res?.data?.start_datetime?.split("T")[1]?.split(":").slice(0, 2).join(":"));
        // setEndDate(res?.data?.end_datetime?.split("T")[0]); // Extract date part
        setEndTime(res?.data?.end_datetime?.split("T")[1]?.split(":").slice(0, 2).join(":"));
        // console.log("response date ", moment(res?.data?.start_datetime).format("YYYY-MM-DD"))
        setStartDate(moment(res?.data?.start_datetime).format("YYYY-MM-DD"));
        // setStartTime(moment(res?.data?.start_datetime).format("hh:mm"));
        setEndDate(moment(res?.data?.end_datetime).format("YYYY-MM-DD"));
        // setEndTime(moment(res?.data?.end_datetime).format("HH:mm"));
        setImages(res?.data?.details ? res.data.details : []);
        setCount(res?.data?.details.length);

      })
      .catch((err) => {
        console.log("err", err);
      });
  };


  const locationView = (type, id) => {
    const formdata = new FormData();
    formdata.append("type", type);
    if (id) {
      formdata.append("parent_id", id);
    }
    setLoader(true);
    bannerlocationApi(formdata)
      .unwrap()
      .then((res) => {
        console.log("res_id", res);
        if (res?.data) {
          const options = res?.data.map((item) => {
            let obj = {};
            obj.value = item.id;
            obj.label = item.name;
            return obj;
          });
          console.log("options", options);
          if (type == 1) {
            setCountryValue(options);
            setLoader(false)
          } else if (type == 2) {
            setStateValue(options);
            setLoader(false)
          } else {
            setCityValue(options);
            setLoader(false)
          }
        }
      })
      .catch((err) => {
        console.log("err", err);
      }).finally(() => {
        setLoader(false);
      })
  };

  const locationStateView = (id) => {
    const formdata = new FormData();
    formdata.append("type", 2);
    if (id) {
      formdata.append("parent_id", id);
    }
    bannerlocationApi(formdata)
      .unwrap()
      .then((res) => {
        console.log("res_id", res);
        if (res?.data) {
          const options = res?.data.map((item) => {
            let obj = {};
            obj.value = item.id;
            obj.label = item.name;
            return obj;
          });
          console.log("options", options);
          setStateValue(options);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const locationCityView = (id) => {
    const formdata = new FormData();
    formdata.append("type", 3);
    if (id) {
      formdata.append("parent_id", id);
    }
    bannerlocationApi(formdata)
      .unwrap()
      .then((res) => {
        console.log("res_id", res);
        if (res?.data) {
          const options = res?.data.map((item) => {
            let obj = {};
            obj.value = item.id;
            obj.label = item.name;
            return obj;
          });
          console.log("options", options);
          setCityValue(options);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  useEffect(() => {
    if (location?.state?.id) {
      adminView(location?.state?.id);
    }

    locationView(1);

  }, []);

  const handleDragStart = (event, index) => {
    event.dataTransfer.setData("text/plain", index);
    event.currentTarget.style.opacity = 0.5;
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    event.dataTransfer.dropEffect = "move";
  };

  const handleDrop = (event, targetIndex) => {
    event.preventDefault();
    const sourceIndex = event.dataTransfer.getData("text/plain");
    if (sourceIndex !== targetIndex) {
      const newImages = [...images];
      const [movedItem] = newImages.splice(sourceIndex, 1);
      newImages.splice(targetIndex, 0, movedItem);
      setImages(newImages);
    }
    event.currentTarget.style.opacity = 1;
  };

  const handleDragEnd = (event) => {
    event.currentTarget.style.opacity = 1;
  };

  return (
    <div className="dashRightView home_section">
      <div className="d-flex ac-jb">
        <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 sec">
          Banners ({count})
        </h2>
      </div>
      <div className="d-flex">
        <div
          className="d-flex ac-js gap-2 pointer"
          onClick={() => navigate(-1)}
        >
          <img src={left_arrow} className="leftArrow mb-3" alt="Back" />
          <p className="f2 fs-sm-10 fs-md-16 fs-lg-16 fs-xl-18 fs-xxl-20 primary">
            Back
          </p>
        </div>
      </div>

      <div>
        <div className="d-flex gap-5 mb-4">
          <div className="col-md-2">
            <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
              Country
            </h4>
            <Select
              isDisabled={type == "view" ? true : false}
              className="input-pop_box"
              options={countryValue}
              value={selectedCountryValue}
              onChange={(e) => {
                locationView(2, e.value);
                setSelectedCountryValue(e);
                setSelectedStateValue('');
                setSelectedCityValue('');
              }}
            />
          </div>
          <div className="col-md-2">
            <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
              State
            </h4>
            <Select
              isDisabled={type == "view" ? true : false}
              className="input-pop_box"
              options={stateValue}
              value={selectedStateValue}
              onChange={(e) => {
                locationView(3, e.value);
                setSelectedStateValue(e);
                setSelectedCityValue('');
              }}
            />
          </div>
          <div className="col-md-2">
            <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
              City
            </h4>
            <Select
              isDisabled={type == "view" ? true : false}
              className="input-pop_box"
              options={cityValue}
              value={selectedCityValue}
              onChange={(e) => setSelectedCityValue(e)}
            />
          </div>
        </div>
        <div className="d-flex gap-5 mb-4">
          <div className="col-md-2">
            <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
              Start Date
            </h4>
            <DatePicker
              selected={startDate}
              onChange={(date) => setStartDate(date)}
              dateFormat="dd-MM-yyyy"
              className="input-pop ps-2 w-100"
              placeholderText="Select a StartDate"
              disabled={type === "view"}
              type="date"
            />
          </div>
          <div className="col-md-2">
            <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
              Start Time
            </h4>
            <input
              value={startTime}
              onChange={(e) => setStartTime(e.target.value)}
              readOnly={type == "view" ? true : false}
              type="time"
              className="input-pop ps-2 w-100"
              placeholder="State"
              />
              {console.log("time",startTime)}
          </div>
          <div className="col-md-2">
            <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
              End Date
            </h4>
            <DatePicker
              selected={endDate}
              onChange={(date) => setEndDate(date)}
              dateFormat="dd-MM-yyyy"
              className="input-pop ps-2 w-100"
              placeholderText="Select a EndDate"
              disabled={type === "view"}
              type="date"
            />
          </div>
          <div className="col-md-2">
            <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
              End Time
            </h4>
            <input
              value={endTime}
              onChange={(e) => setEndTime(e.target.value)}
              readOnly={type == "view" ? true : false}
              type="time"
              className="input-pop ps-2 w-100"
              placeholder="City"
            />
          </div>
        </div>
        {type != "view" && (
          <div>
            <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
              Upload Images (4850 x 3230)Pixels
            </h4>
            <input
              ref={ref}
              type="file"
              onChange={handleChange}
              multiple={true}
              accept="image/*"
              hidden
            />
            <button
              useRef="image"
              onClick={() => ref.current.click()}
              className="upload-btn-new f2 fs-sm-10 fs-md-8 fs-lg-10 fs-xl-12 fs-xxl-14 mb-3 py-2"
            >
              Upload
            </button>
          </div>
        )}

        <div className=" ">
          {images?.map((item, i) => {
            return (
              <div
                className="mb-3"
                key={i} // Use index as key since items might not have unique IDs
                draggable
                onDragStart={(e) => handleDragStart(e, i)}
                onDragOver={handleDragOver}
                onDrop={(e) => handleDrop(e, i)}
                onDragEnd={handleDragEnd}
              >
                <div className="d-flex ac-js">
                  <div
                    className="position-relative"
                    style={{ display: "inline-block" }}
                  >
                    <img
                      src={item?.image_url ? item?.image_url :
                        item?.image?.name ?
                          URL.createObjectURL(item?.image) : item?.image
                      }
                      className="img-drag"
                      alt={item?.image?.name || "Banner Image"}
                    />
                    {type != "view" && (
                      <button
                        className="cancel-btn f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary cust-btn"
                        onClick={() => {
                          const newImages = images.filter(
                            (_, index) => index !== i
                          );
                          setImages(newImages);
                        }}
                      >
                        <CancelIcon />
                      </button>
                    )}
                  </div>
                  <input
                    readOnly={type == "view" ? true : false}
                    onChange={(e) => handleImgUrl(e.target.value, i)}
                    value={item?.redirection_url && item?.redirection_url != "undefined" ? item?.redirection_url : ""}
                    type="url"
                    className="input-pop ps-2 w-50 ms-3"
                    placeholder="Enter URL"
                  />
                </div>
                <p className="f1 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18">
                  {item?.image?.name || "Banner Image"}
                </p>
              </div>
            );
          })}
        </div>
        {type != "view" && (
          <div className="d-flex ac-je">
            <button
              onClick={() => (type == "edit" ? bannerEdit() : bannerAdd())}
              className="login-btn f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 "
            >
              Submit
            </button>
          </div>
        )}
      </div>
      {loader && (<div style={{ zIndex: 2000, position: "fixed", top: "45%", left: "49%", }}  >
        <Spinner animation="border" className="primary1" />
      </div>
      )}
    </div>
  );
};

export default AddBanners;
